import { CSSProperties } from 'react';

export const radioGroupStyles: CSSProperties = {
  display: 'flex',
  gap: '12px'
};

export const radioLabelStyles = (isSelected: boolean): CSSProperties => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '48px',
  borderRadius: '14px',
  border: isSelected ? '2px solid #1A1A1A' : '2px solid transparent',
  backgroundColor: '#fff',
  padding: '0',
  cursor: 'pointer',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)',
  fontWeight: isSelected ? '600' : '400'
});

export const radioBoxStyles: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '15px',
  color: '#1A1A1A',
  margin: 0
};
